export const SESSION_EXPIRED_ROUTE_PATH = "/session-expired";
